var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"rounded-lg _safeAreaInsetContentMarginTop _box-shadow",staticStyle:{"hyphens":"auto","overflow-y":"auto"},attrs:{"id":"sheet","rounded":"","height":`calc(100vh - ${_vm.boundedContentHeight}px - env(safe-area-inset-top))`}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }